import http from './_http'

const login = {
  get: (id) => http.get(`api/v3/log/login/${id}`),
  list: (m) => http.post(`api/v3/log/login/search`, m),
}

const system = {
  get: (id) => http.get(`api/v3/log/system/${id}`),
  list: (m) => http.post(`api/v3/log/system/search`, m),
}


const log  = {
  login, system,
}
export default log
export { login, system }
